import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertContainer } from '@shared/components/alert-container/alert-container';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertContainer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
